import { GlobalResponseObject } from "../../../global-response-object";
import { LinesReworkModel } from "./lines-rework.model";

export class OperatorReworkResponse extends GlobalResponseObject{
    data?: LinesReworkModel;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LinesReworkModel){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}
